export default {
    data () {
        return {
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return 'table-header-cell'
                    }
                },
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return 'table-row-cell'
                }
            },
            cellSelectionOption: {
                enable: false
            },
            sortOption: {
                sortAlways: true,
                sortChange: (params) => {
                    this.sortChange(params)
                },
            }
        }
    },
    methods: {
        sortChange (params) {
            Object.entries(params)
                .filter(([key, value]) => value !== '')
                .forEach(([key, value]) => {
                    this.data.sort((a, b) => {
                        if (a[key] === null) {
                            return 1
                        }
                        if (b[key] === null) {
                            return -1
                        }
                        if (typeof a[key] === 'number') {
                            return value === 'asc'
                                ? a[key] - b[key]
                                : b[key] - a[key]
                        }
                        if (typeof a[key] === 'string') {
                            return value === 'asc'
                                ? a[key].localeCompare(b[key])
                                : b[key].localeCompare(a[key])
                        }
                    })
                })
        }
    }
}
